import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import Reveal, { StaggerContainer, RevealChild } from "../components/Reveal";
import AdvertiseBanner from "../components/AdvertiseBanner";
import "../styles/Home.css";

// Assets
import heroBg from "../assets/hero.jpg"; 
import infoIcon from "../assets/info-icon.png";

const RSS_API_KEY = 'unrobsdshc0uiipzo2eqw63dccehc2xnxrdb5oax';
const RSS_URL = 'https%3A%2F%2Fthenewpccm.substack.com%2Ffeed';

const CoreValues = () => (
  <div className="tab-content">
    <div className="value-item">
      <h3>Integrity and Accountability</h3>
      <p>
        We strive to be effective in achieving our role and accountability to our members and stakeholders.
        We believe in modelling trustworthiness and integrity that earns the public's high regard.
      </p>
    </div>
    <div className="value-item">
      <h3>Service and Responsible Stewardship</h3>
      <p>
        We are committed to a strong ethic of timely and reliable service. We manage all human, natural,
        and financial resources carefully, wisely spending funds that accrue to the organization.
      </p>
    </div>
  </div>
);

const CodeOfEthics = () => (
  <div className="tab-content">
    <p>
      As a non-profit organization, we maintain our respect for communities and responsibility for all our decisions.
      We are committed to:
    </p>
    <ul className="ethics-list">
      <li>Acting honestly, truthfully, and with integrity in all our transactions.</li>
      <li>Avoiding conflicts of interest.</li>
      <li>Treating every individual with dignity and respect.</li>
      <li>Being responsible, transparent, and accountable.</li>
      <li>Refraining from using our position for personal, political, or financial gain.</li>
    </ul>
  </div>
);

function Home() {
  const [news, setNews] = useState([]);
  const [bod, setBod] = useState([]);
  const [members, setMembers] = useState([]);
  const [programs, setPrograms] = useState([]);
  const [activeTab, setActiveTab] = useState("values");
  const [metrics, setMetrics] = useState([]);

  // Fetch Data
  useEffect(() => {
    const fetchData = async () => {
      try {
        // News
        fetch(`https://api.rss2json.com/v1/api.json?rss_url=${RSS_URL}&api_key=${RSS_API_KEY}`)
          .then(res => res.json())
          .then(data => { if(data.items) setNews(data.items.slice(0, 3)); });

        // About Us (Board)
        fetch("/api/aboutus")
          .then(res => res.json())
          .then(data => {
            setBod(data.boardOfDirectors || []);
            setMembers(data.boardMembers || []);
          });

        // Events (Programs)
        fetch("/api/events")
          .then(res => res.json())
          .then(data => {
            setPrograms(data.programs || []);
          });

        fetch("/api/metrics")
          .then((res) => res.json())
          .then((data) => setMetrics(Array.isArray(data.stats) ? data.stats : []));

      } catch (e) {
        console.error("Fetch error", e);
      }
    };
    fetchData();
  }, []);

  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero-section" id="top" style={{ backgroundImage: `url(${heroBg})` }}>
        <div className="hero-overlay"></div>
        <div className="container hero-content">
          <Reveal>
            <h1 className="hero-title text-left">Philippine Canadian Centre of Manitoba</h1>
            <p className="hero-subtitle text-left">Serving the community since the 1990s.</p>
            <div className="hero-actions">
              <HashLink smooth to="/#events" className="btn btn-primary">Upcoming Events</HashLink>
              <Link to="/advertise" className="btn btn-secondary">Advertise with Us</Link>
              <Link to="/memberships" className="btn btn-secondary">Become a Member</Link>
              <HashLink smooth to="/#news" className="btn btn-outline">Latest News</HashLink>
            </div>
            <div className="hero-stats">
              {(metrics.length ? metrics : [
                { label: "Years of Service", value: "25+" },
                { label: "Community Programs", value: "50+" },
                { label: "Facebook Followers", value: "2.4k" },
                { label: "Filipino-Canadians in Manitoba", value: "90k" },
              ]).map((m, idx) => (
                <div key={idx} className="stat-card glass compact">
                  <h3>{m.value}</h3>
                  <p>{m.label}</p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </section>

      {/* Intro / Story Section */}
      <section className="section" id="about">
        <div className="container">
          <Reveal>
            <div className="intro-grid">
              <div className="intro-text">
                <h2>Serving the Community Since the 1990s</h2>
                <p>
                  The PCCM is a charitable non-profit Filipino-Canadian organization since the 1990s. The Philippine Canadian Centre of Manitoba (PCCM) traces its origins to the late 1980s when the Filipino-Canadian community in Winnipeg embarked on a journey to establish a larger cultural hub. Initially housed in a modest facility at the corner of Juno Street and McDermot Avenue, discussions between community leaders and city officials in 1989 led to the proposal for a larger and dedicated Philippine Cultural Centre. Negotiations with the City of Winnipeg culminated in a 50-year lease agreement for a 2.96-acre plot at a nominal cost of $1 per year, despite adjustments to the project scope due to logistical challenges. Following these negotiations, the Philippine Centre Fundraising Committee was formed, later evolving into the Philippine Foundation of Manitoba, Inc., and ultimately incorporating as the Philippine Canadian Centre of Manitoba, Inc. in November 1998. Since its inception, PCCM has been a cornerstone of cultural identity and community pride, celebrating many years of enriching Filipino-Canadian heritage and serving as a vibrant hub for cultural, social, and educational activities in Winnipeg and Manitoba.
                </p>
                <HashLink smooth to="/#mission" className="btn btn-accent btn-sm">Our Mission</HashLink>
              </div>
            </div>
          </Reveal>
        </div>
      </section>

      {/* Mission & Values */}
      <section className="section section-alt" id="mission">
        <div className="container">
          <Reveal>
            <div className="center-header">
               <h2>Our Mission & Values</h2>
               <p className="mission-intro">
                 We seek to nurture the spirit of a non-profit organization by recognizing and celebrating successes 
                 and learning from valuable failures.
               </p>
            </div>
            
            <div className="tabs">
              <button 
                className={`tab-btn ${activeTab === 'values' ? 'active' : ''}`}
                onClick={() => setActiveTab('values')}
              >
                Core Values
              </button>
              <button 
                className={`tab-btn ${activeTab === 'ethics' ? 'active' : ''}`}
                onClick={() => setActiveTab('ethics')}
              >
                Code of Ethics
              </button>
            </div>

            <div className="tab-panel card">
              {activeTab === 'values' ? <CoreValues /> : <CodeOfEthics />}
            </div>
          </Reveal>
        </div>
      </section>

      {/* Advertise / Sponsors */}
      <section className="section" id="advertise-home">
        <div className="container">
          <Reveal>
            <div className="section-header">
              <div>
                <h2>Partner With PCCM</h2>
                <p className="text-muted">
                  Showcase your brand to a vibrant community and support the Centre’s programs.
                </p>
              </div>
              <Link to="/advertise" className="btn btn-primary">Advertise with Us</Link>
            </div>
            <div className="ad-home-card card">
              <div className="ad-home-ctaimg">
                <img src={require("../assets/ctaimage.png")} alt="Person using phone" />
              </div>
              <AdvertiseBanner />
              <div className="ad-home-meta">
                <div>
                  <h4>Digital + In-Centre visibility</h4>
                  <p className="text-muted">Website placements, newsletter features, and event spotlights.</p>
                </div>
                <div className="ad-home-cta">
                  <Link to="/advertise" className="btn btn-secondary btn-sm">View Packages</Link>
                  <a href="mailto:president@thenewpccm.ca" className="btn btn-outline btn-sm">Talk to Us</a>
                </div>
              </div>
              <div className="ad-home-sponsor card-content">
                <div>
                  <p className="text-muted" style={{ marginBottom: 4 }}>Featured partner</p>
                  <h4>Bison Business Communications</h4>
                  <p className="text-muted">Local telecom and IT services supporting PCCM.</p>
                </div>
                <a href="https://bisonbusinesscommunications.ca/" target="_blank" rel="noreferrer" className="btn btn-primary btn-sm">
                  Visit Bison Business
                </a>
              </div>
            </div>
          </Reveal>
        </div>
      </section>

      {/* Board Leadership */}
      <section className="section section-dark" id="leadership">
        <div className="container">
          <div className="section-header">
            <h2 className="text-light">Our Leadership</h2>
          </div>
          
          <div className="sub-section-title">Board of Directors</div>
          <StaggerContainer className="grid-4 team-grid">
            {bod.map((member, idx) => (
              <RevealChild key={idx} className="card member-card">
                <div className="card-img-wrap">
                  <img 
                    src={member.image || infoIcon} 
                    alt={member.name} 
                    className="card-img"
                    onError={(e) => {e.target.src = infoIcon}} 
                  />
                  {/* Swapped order for CSS ~ selector to work */}
                  {member.description && (
                      <div className="book-icon-wrapper" title="Read Bio">
                         <span className="book-icon">📖</span>
                      </div>
                  )}
                  {member.description && (
                    <div className="desc-overlay">
                      <p>{member.description}</p>
                    </div>
                  )}
                </div>
                <div className="card-content relative">
                  <h4 className="member-name">{member.name}</h4>
                  <p className="role">{member.position}</p>
                </div>
              </RevealChild>
            ))}
          </StaggerContainer>

          {members.length > 0 && (
            <>
              <div className="sub-section-title" style={{marginTop: "4rem"}}>Board Members</div>
              <StaggerContainer className="grid-4 team-grid">
                {members.map((member, idx) => (
                  <RevealChild key={idx} className="card member-card">
                    <div className="card-img-wrap">
                      <img 
                        src={member.image || infoIcon} 
                        alt={member.name} 
                        className="card-img"
                        onError={(e) => {e.target.src = infoIcon}} 
                      />
                       {/* Swapped order for CSS ~ selector to work */}
                      {member.description && (
                          <div className="book-icon-wrapper" title="Read Bio">
                             <span className="book-icon">📖</span>
                          </div>
                      )}
                      {member.description && (
                        <div className="desc-overlay">
                          <p>{member.description}</p>
                        </div>
                      )}
                    </div>
                    <div className="card-content relative">
                      <h4 className="member-name">{member.name}</h4>
                      <p className="role">Board Member</p>
                    </div>
                  </RevealChild>
                ))}
              </StaggerContainer>
            </>
          )}
        </div>
      </section>

      {/* Events Calendar */}
      <section className="section" id="events">
        <div className="container">
          <Reveal>
            <div className="section-header">
              <h2>Upcoming Events</h2>
            </div>
            <div className="calendar-wrapper card">
               <div data-tockify-component="mini" data-tockify-calendar="thepccm" data-tockify-view="agenda"></div>
            </div>
          </Reveal>
        </div>
      </section>

      {/* Programs */}
      <section className="section section-alt" id="programs">
        <div className="container">
           <Reveal>
             <div className="section-header">
               <h2>Programs & Services</h2>
               <p>Supporting the Filipino community and our neighbors.</p>
             </div>
           </Reveal>
           <StaggerContainer className="grid-3">
            {programs.map((prog, i) => (
              <RevealChild key={i} className="card program-card">
                <div className="card-img-wrap" style={{ aspectRatio: "16/9" }}>
                  <img src={prog.image || infoIcon} alt={prog.title} className="card-img" onError={(e) => {e.target.src = infoIcon}}/>
                </div>
                <div className="card-content">
                  <h3>{prog.title}</h3>
                  <p>{prog.description}</p>
                  {prog.link && (
                    <a href={prog.link} target="_blank" rel="noreferrer" className="btn-link">Learn More</a>
                  )}
                </div>
              </RevealChild>
            ))}
          </StaggerContainer>
        </div>
      </section>

      {/* Latest News */}
      <section className="section" id="news">
        <div className="container">
          <div className="section-header">
            <h2>Latest News</h2>
          </div>
          <StaggerContainer className="grid-3">
            {news.map((item, idx) => (
              <RevealChild key={idx} className="card news-card">
                <div className="card-img-wrap" style={{ height: "200px" }}>
                  <img src={item.thumbnail || infoIcon} alt={item.title} className="card-img" />
                </div>
                <div className="card-content">
                  <span className="news-date">{new Date(item.pubDate).toLocaleDateString()}</span>
                  <h3>{item.title}</h3>
                  <a href={item.link} target="_blank" rel="noreferrer" className="read-more">Read on Substack</a>
                </div>
              </RevealChild>
            ))}
          </StaggerContainer>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section cta-section">
        <div className="container">
          <Reveal>
            <h2>Join Our Community</h2>
            <p>Become a member today or support us through a donation.</p>
            <div className="cta-buttons">
              <Link to="/memberships" className="btn btn-primary">Become a Member</Link>
              <Link to="/donate" className="btn btn-outline">Donate Now</Link>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}

export default Home;
